export const userDetailViewSections = [
  {
    title: "CAF Status",
    fields: [
      { name: "entity_name", label: "Entity Name" },
      { name: "created_at", label: "Created At" },
      { name: "updated_at", label: "Updated At" },
      { name: "caf_status", label: "CAF Status" },
    ],
  },
  {
    title: "Unit Details",
    fields: [
      { name: "application_name", label: "Application Name" },
      { name: "mobile_number", label: "Mobile Number" },
      { name: "district_name", label: "District" },
      { name: "unit_name", label: "Unit Name" },
      { name: "unit_address", label: "Unit Address" },
      { name: "nic_code", label: "NIC Code" },
      { name: "unit_description", label: "Unit Description" },
    ],
  },
  {
    title: "Investment Details",
    fields: [
      { name: "investment_in_land", label: "Investment in Land" },
      { name: "investment_in_building", label: "Investment in Building" },
      { name: "investment_in_peq", label: "Investment in Plant & Equipment" },
      { name: "investment_in_other", label: "Investment in Other" },
      { name: "total_investment", label: "Total Investment Amount" },
      { name: "employment", label: "Employment" },
      { name: "project_details", label: "Project Details" },
      { name: "investor_details", label: "Investor Details" },
    ],
  },
  {
    title: "Project Status (Construction)",
    fields: [
      { name: "land_available", label: "Land Availability" },
      { name: "section_143_approval", label: "Section 143 Approval" },
      { name: "ec_pcb", label: "Environmental Clearance (PCB)" },
      { name: "cte_pcb", label: "Consent to Establish (PCB)" },
      { name: "building_plan_approval", label: "Building Plan Approval" },
      { name: "construction_status", label: "Construction Status" },
      {
        name: "start_date_of_construction",
        label: "Start Date of Construction",
      },
      {
        name: "expected_date_of_completion",
        label: "Expected Date of Completion",
      },
      {
        name: "completion_date_of_construction",
        label: "Completion Date of Construction",
      },
    ],
  },
  {
    title: "Project Status (Operations)",
    fields: [
      { name: "cto_pcb", label: "Consent to Operate (PCB)" },
      { name: "noc_fire", label: "Fire NOC" },
      { name: "travel_trade_registration", label: "Travel Trade Registration" },
      { name: "commercial_operation_date", label: "Commercial Operation Date" },
      {
        name: "available_incentive_scheme",
        label: "Available Incentive Scheme",
      },
    ],
  },
];
